// extracted by mini-css-extract-plugin
export default {"footer":"Total-module--footer--992f9","red":"Total-module--red--f836e"};